module.exports = __webpack_public_path__ + "img/25.0cbe349d.png";